import Validator from "js-object-validation";
import { message } from "../common";

export const timeFormater = (data) => {
  const validations = {
    date: {
      required: true,
    },
    time: {
      required: true,
    },
  };

  const messages = {
    date: {
      required: message.Required.replace(":item", "date format"),
    },
    time: {
      required: message.Required.replace(":item", "time format"),
    },
  };

  const { isValid, errors } = Validator(data, validations, messages);
  return {
    isValid,
    errors,
  };
};
